module.exports = __webpack_public_path__ + "static/exterior-1-946b4e71c19572b435673a424a33e788.jpg";